var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c(
        "div",
        {
          staticClass: "input--text input-number",
          class: { "right-padding": _vm.removeIcon },
        },
        [
          _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
            _vm._v(_vm._s(_vm.$t(_vm.literal))),
          ]),
          _c("div", { staticClass: "input__wrapper" }, [
            _c("input", {
              attrs: {
                name: _vm.name,
                type: _vm.type,
                disabled: _vm.disabled,
                autocomplete: _vm.autocomplete,
                inputmode: _vm.inputmode,
                min: _vm.shouldValidateNumericField(_vm.name) ? "1" : null,
              },
              domProps: { value: _vm.value },
              on: {
                change: function ($event) {
                  return _vm.handleChange($event)
                },
                input: function ($event) {
                  return _vm.handleInput($event)
                },
                keydown: function ($event) {
                  return _vm.handleKeydown($event)
                },
              },
            }),
            _c(
              "span",
              { staticClass: "input__icon" },
              [
                _c("svgicon", {
                  attrs: { icon: _vm.icon, height: "18", color: "#FFFFFF" },
                }),
              ],
              1
            ),
            _vm.showRemoveIcon
              ? _c(
                  "span",
                  { staticClass: "remove__icon" },
                  [
                    _c("svgicon", {
                      staticClass: "svg-icon svg-icon-action",
                      attrs: { icon: "delete", height: "13" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("remove")
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }